import { render } from "./BadgeSale.vue?vue&type=template&id=09ee47ca"
import script from "./BadgeSale.vue?vue&type=script&lang=js"
export * from "./BadgeSale.vue?vue&type=script&lang=js"

import "./BadgeSale.vue?vue&type=style&index=0&id=09ee47ca&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__